/**
 * Composable for branding-related utilities
 * Provides methods to customize text with installation-specific branding
 */
import { useMapGetter } from 'dashboard/composables/store.js';

export function useBranding() {
  const globalConfig = useMapGetter('globalConfig/get');
  /**
   * Replaces brand tokens in text with the active installation brand
   * @param {string} text - The text to process
   * @returns {string} - Text with "Chatwoot" replaced by installation name
   */
  const replaceInstallationName = text => {
    if (!text) return text;

    const replacementName =
      globalConfig.value?.brandName || globalConfig.value?.installationName;
    if (!replacementName) return text;

    return text.replace(/Chatwoot|juump\.to/g, replacementName);
  };

  return {
    replaceInstallationName,
  };
}
